import React from 'react'; 

export const sharedColumns = [
    {
        name: 'User Id',
        key: 'userId',
        fieldName: 'userId',
        minWidth: 50,
        maxWidth: 50,
        isResizable: true,
    },
    {
        name: 'Full Name',
        key: 'fullName',
        fieldName: 'fullName',
        minWidth: 50,
        maxWidth: 100,
        isResizable: true
    },
    {
        name: 'Birthdate',
        key: 'birthdate',
        fieldName: 'birthdate',
        minWidth: 30,
        maxWidth: 80,
        isResizable: true,
    },
    {
        name: 'Cobrand',
        key: 'cobrand',
        fieldName: 'cobrand',
        minWidth: 30,
        maxWidth: 80,
        isResizable: true,
    },
    {
        name: 'Email',
        key: 'email',
        fieldName: 'email',
        minWidth: 50,
        maxWidth: 180,
        isResizable: true,
    },
    {
        name: 'EntryRef',
        key: 'entryRef',
        fieldName: 'entryRef',
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
];

export const datetimeColumn = (title) => {
    return {
        key: 'createdOn',
        name: title,
        fieldName: 'createdOn',
        minWidth: 60,
        maxWidth: 165,
        isResizable: true,
        data: 'number',
        onRender: (item) => {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZoneName: 'short',
            };
            const intlFormatted = new Intl.DateTimeFormat('en-US', options).format(new Date(item.createdOn));
            return <span>{intlFormatted}</span>;
        }
    };
}
